import React, { useMemo } from 'react';
import clsx from 'clsx';
import { _SOCCER_TIME_LINE } from '../../../../../../common/constants/sportsConstants';

const SoccerMatchBroadcastItem = ({ item }) => {
  const { eventType, locationType, playText, score, displayTime } = item;

  const eventClass = useMemo(() => {
    /**
     * "GOAL"
     * "YELLOW_CARD"
     * "PK_SUCCESS" //패널티킥 성공
     * "OWN_GOAL" //자책점
     * "RED_CARD"
     * "YELLOW_TO_RED" //경고 누적으로 인한 퇴장
     * "PK_FAIL" //패널티킥 실패
     * "SHOOTOUT_FIRST_SHOOTING_TEAM_INDICATE"  //승부차기 선제권 팀 표시를 위한 타입
     * "SHOOTOUT_SUCCESS" //승부차기 성공
     * "SHOOTOUT_FAIL" //승부차기 실패
     * "HALFTIME" //전반 종료 알림을 위한 타입
     * "FULLTIME" //후반 종료 알림을 위한 타입
     * "SUBSTITUTE" //교체
     * "NORMAL" //그외-캐스터에서 삽입된 문자중계
     * "GAME_START"
     * "SECOND_START"
     * "GAME_PAUSE"
     * "OVERTIME_START계
     * "SHOOTOUT_START"
     * "GAME_RESUME"
     * "CUT"
     * "SECOND_END"
     * "OVERTIME_END"
     */
    if (
      eventType === 'GAME_START' ||
      eventType === 'HALFTIME' ||
      eventType === 'SECOND_START' ||
      eventType === 'FULLTIME'
    ) {
      return 'start';
    } else if (eventType === 'SUBSTITUTE') {
      return 'change';
    } else {
      return eventType.toLowerCase();
    }
  }, [eventType]);

  const ItemDom = (result, eventClass) => {
    return (
      <div key={result.time} className={clsx('item')}>
        {!!result.home && result.home}
        {!!result.away && result.away}
        <div className={clsx('event', eventClass)}>{playText}</div>
      </div>
    );
  };

  return useMemo(() => {
    const timeArr = displayTime.split(':');
    const time = `${parseInt(timeArr[0]) * 60 + parseInt(timeArr[1])}`;
    const location = locationType.toLowerCase();

    let elements = [];
    let result = {
      home: undefined,
      away: undefined,
      time
    };

    if (_SOCCER_TIME_LINE.hasOwnProperty(eventType)) {
      result.time = _SOCCER_TIME_LINE[eventType];
      elements = [ItemDom(result, eventClass)];
    } else if (
      eventType === 'GOAL' ||
      eventType === 'OWN_GOAL' ||
      eventType === 'PK_SUCCESS' ||
      eventType === 'PK_FAIL' ||
      eventType === 'YELLOW_CARD' ||
      eventType === 'RED_CARD' ||
      eventType === 'YELLOW_TO_RED'
    ) {
      const textArr = playText.split(' ');
      const last = textArr.pop();
      const scoreText = `${score.home}:${score.away}`;
      const scoreVisible =
        eventType === 'GOAL' ||
        eventType === 'PK_SUCCESS' ||
        eventType === 'OWN_GOAL';

      result[location] = [
        <div key={result.time} className={clsx('team', location)}>
          <span className="player">{textArr.join(' ')}</span>
          <span className="cont">
            {`${last}${scoreVisible ? ` ${scoreText}` : ''}`}
          </span>
          <span className="time">{result.time}분</span>
        </div>
      ];

      if (location === 'away') {
        result[location] = result[location].reverse();
      }

      elements = [ItemDom(result, eventClass)];
    } else if (eventType === 'SUBSTITUTE') {
      let subst = playText.split(',');

      result[location] = [
        <div className={clsx('team', location)}>
          <span className="player">{subst[0].replace(' OUT', '')}</span>
          <span className="cont">{subst[1].replace(' IN', '')}</span>
          <span className="time">{result.time}분</span>
        </div>
      ];

      if (location === 'away') {
        result[location] = result[location].reverse();
      }

      elements = [ItemDom(result, eventClass)];
    }

    return elements;
  }, [locationType, playText, eventType, score, eventClass, displayTime]);
};

export default SoccerMatchBroadcastItem;
